import { render, staticRenderFns } from "./mailList.vue?vue&type=template&id=4f8a5b4f&"
import script from "./mailList.vue?vue&type=script&lang=js&"
export * from "./mailList.vue?vue&type=script&lang=js&"
import style0 from "./mailList.vue?vue&type=style&index=0&id=4f8a5b4f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports